import React from "react"
import { View } from "./primitives"

export default function Toast() {
  return null
}

export function EasyToast({ ref: _ref }: { ref?: React.Ref<unknown> }) {
  return <View />
}
